import axiosTokenInstance from 'services/api/backoffice';
import { MY_SALES_EXECUTIVE, MY_SALES_EXECUTIVE_ERROR } from '_models/redux/types';

// Action function
export const getMySalesExecutive = (params) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `/api/callcenter/reports/sales?from_date=${params.from_time}&to_date=${params.to_time}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: MY_SALES_EXECUTIVE,
      payload: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: MY_SALES_EXECUTIVE_ERROR,
      payload: e || {},
    });
  }
};
